export default __webpack_public_path__ + "static/media/desarrollo.84f68fb1.gif";